import { Button, Divider, Input } from "antd";
import call from "./../../assets/images/call.svg";
import info from "./../../assets/images/info.svg";
import arrowLeft from "./../../assets/images/arrow-left.svg";
import ProgressIndicator from "../../commonComponents/ProgressIndicator";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const PatientPhoneNo = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [mobileNumber, setMobileNumber] = useState(state?.mobileNumber || "");
  const [isContinueDisabled, setIsContinueDisabled] = useState(true);

  useEffect(() => {
    if (mobileNumber) {
      validatePhoneNumber(mobileNumber);
    }
  }, []);

  const validatePhoneNumber = (phoneNumber: string) => {
    if (phoneNumber.length === 10) {
      setIsContinueDisabled(false);
    } else if (phoneNumber.length > 10) {
      setIsContinueDisabled(true);
    } else {
      setIsContinueDisabled(true);
    }
  };

  const phoneNumberHandler = (e: any) => {
    const input = e.target.value;

    // Allow only numbers
    if (/^\d*$/.test(input)) {
      setMobileNumber(input);

      // Update isContinueDisabled based on input length
      validatePhoneNumber(input);
    }
  };

  const backBtnHandler = () => {
    navigate("/patient-care-program", {
      state: { ...state },
    });
  };

  const continueBtnHandler = () => {
    navigate("/patient-name", {
      state: {
        ...state,
        mobileNumber: mobileNumber,
      },
    });
  };

  return (
    <div className="p-6">
      <div className="flex items-start font-semibold gap-x-2 pb-5">
        <img
          height={22}
          width={22}
          src={arrowLeft}
          alt="arrow-left"
          onClick={backBtnHandler}
        />
        <span>Refer care plan</span>
      </div>
      <ProgressIndicator currentStep={3} totalSteps={4} />
      <div className="flex flex-col flex-start pt-6 gap-y-6">
        <span className="font-semibold text-2xl text-left">
          Enter your patient's mobile number
        </span>
        <div>
          <label className="text-sm pb-2 flex">Patient mobile number</label>
          <Input
            placeholder="Enter your phone number"
            prefix={
              <>
                <img src={call} alt="user" className="p-2" />
                {" +91 "}
              </>
            }
            onChange={phoneNumberHandler}
            value={mobileNumber}
            name="doctorName"
            inputMode="numeric"
            maxLength={10}
            autoFocus={true}
          />
        </div>
        <div className="flex items-center gap-x-2 bg-[#FDF7D7] p-2 rounded-2xl">
          <img src={info} alt="info" />
          <span className="text-xs text-left">
            Whatsapp message will be sent to this patient number referring the
            care plan
          </span>
        </div>
      </div>

      <div className="w-full fixed bottom-0 left-0">
        <div className="mx-auto max-w-[1280px] w-full">
          <Divider />
          <div className="p-6 pt-0">
            <Button
              type="primary"
              className="w-full h-14 rounded-2xl bg-[#4B4AD5] p-5 text-lg font-medium"
              onClick={continueBtnHandler}
              disabled={isContinueDisabled}
            >
              Continue
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientPhoneNo;
